export enum AcuteAMRGrade {
    Active = 0,
    ChronicActive = 1,
    ChronicInactive = 2
}